import Swup from 'swup';
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin/dist/SwupScriptsPlugin.min';
// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

import MiniMasonry from "minimasonry";
import lozad from 'lozad';


const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [
    // new SwupScriptsPlugin({
    //   optin: true
    // })
  ]
};


function l(m) {
  if(window.location.hostname == 'templo.test') {
    console.log(m);
  }
}
  
window.miniMasonry = MiniMasonry

const swup = new Swup(options); 


Alpine.plugin(intersect)

// // Events
swup.on('contentReplaced', init);

// // Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

window.checkImagesLoaded = function() {
  // Get all the images on the page
  let imagesLoaded = 0;
  var images = document.querySelectorAll('.work_entry img');

  for (var i = 0; i < images.length; i++) {
    var img = new window.Image();
    img.src = images[i].src;
    img.onload = function() {
      imagesLoaded++;
    }
  }
  if (imagesLoaded == images.length) {
    // If all the images have finished loading, do something
    l('All images have finished loading');
    loadMasonry()
  }
}

function init() {
  l('👍');
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });

  observer.observe();

  if(document.querySelector('.work_news')) {
    l('news item clicked')
    setTimeout(function() {
      l('init masonry');
      loadMasonry();
    }, 500);
    checkImagesLoaded();    
  }

  if(document.querySelector('.work_filters a')) {
    l('work filters clicked')
    setTimeout(function() {
      l('init masonry');
      loadMasonry();
    }, 500);
    checkImagesLoaded();    
  }
  
  if(document.querySelector('.homescroll') && !isMobile) {
    homeLoop()
  }
  

  
  // startSliders();
  // cookieNotice();
}

function loadMasonry() {
  l('load masonry');
  if(document.querySelector('.work_news')) {
    let cols = isMobile ? 300 : document.querySelector('.work_news').clientWidth / 4;
    l('cols' +  cols);
    let masonry = new MiniMasonry({
      container: '.work_news',
      baseWidth: cols,
      surroundingGutter: false,
      gutterX: 30,
      gutterY: 60
    });
    masonry.layout();
  }
}


function homeLoop() {
  l('home loop');
  // container / elems
  const right = document.querySelector(".right")

  // make clone of the current element and add after 
  const elems = document.querySelector(".scroll-elements")
  const clone = elems.cloneNode(true)
  const parent = elems.parentElement
  parent.appendChild(clone)
  parent.scrollTo(0, 2);

  const left = document.querySelector(".left")
  const altelems = document.querySelector(".scroll-elements-alt")
  const altclone = altelems.cloneNode(true)
  const altparent = altelems.parentElement
  altparent.appendChild(altclone)
  altparent.scrollTo(0, 2);

  // scroll within container
  right.addEventListener("scroll", (e)=> {
    
    // l()      
    // l(container.offsetHeight + container.scrollTop + ' ' + container.scrollHeight)      
    let ratio = (window.innerWidth/2) / window.innerHeight;
    let altScrollPos = right.scrollTop / ratio;

    // match alt container scroll
    left.scrollTo(altScrollPos, 0)
    
    // if the bottom of the current container
    if(Math.floor(right.offsetHeight + right.scrollTop) + 1 >= right.scrollHeight){
      l('og bottom');
      observer.observe();
      const elems = document.querySelector(".scroll-elements")
      // creatte a clone
      const clone = elems.cloneNode(true)
      const parent = elems.parentElement
      // add clone after current elems
      parent.appendChild(clone)
      // remove the original
      parent.children[0].remove()
    } 

    // if at the top of the container
    if(right.scrollTop == 0){
      l('og top');
      observer.observe();
      // make a clone of the elements
      const elems = document.querySelector(".scroll-elements")
      const clone = elems.cloneNode(true)
      // add the clone before the current elems
      const parent = elems.parentElement
      parent.insertBefore(clone, parent.firstChild)
      // scroll to bottom of original
      parent.scrollTo(0, elems.scrollHeight)
      // remove original
      parent.lastElementChild.remove()
    } 
    
    // if the bottom of the current container
    if(Math.floor(left.offsetHeight/ratio + left.scrollTop) + 1 >= left.scrollHeight){
      l('alt bottom')
      const aelems = document.querySelector(".scroll-elements-alt");
      // create a clone
      const aclone = aelems.cloneNode(true)
      const aparent = aelems.parentElement
      // add clone after current elems
      aparent.appendChild(aclone)
      // remove the original
      aparent.children[0].remove()
    } 

    // l(altcontainer.scrollTop)
    // if at the top of the container
    if(left.scrollLeft == 0){
      l('alt top')
      // make a clone of the elements
      const aelems = document.querySelector(".scroll-elements-alt")
      const aclone = aelems.cloneNode(true)
      // add the clone before the current elems
      const aparent = aelems.parentElement
      aparent.insertBefore(aclone, aparent.firstChild)
      // scroll to bottom of original
      aparent.scrollTo((aelems.scrollWidth), 0)
      // remove original
      aparent.lastElementChild.remove()
    } 
  });

}


// // function startSliders() {
// //   if(document.querySelectorAll('.splide').length) { 
// //     let perPage = isMobile ? 1.5 : 3.5;
// //     let splide = new Splide( '.splide', {
// //       type: 'loop',
// //       focus  : 'left',
// //       perPage: perPage,
// //       arrows: true,
// //       pagination: false
// //     });

// //     splide.mount();
// //   }

// // }

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }